import React, { PropTypes } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { getQuestionsWithAnswers } from 'funnel/selectors/question';
import { getProductsWithDecision } from 'funnel/selectors/product';
import cx from 'classnames';
import ScoringTabHeader from 'funnel/components/detail/scoring/ScoringTabHeader';
import ScoringTabContent from 'funnel/components/detail/scoring/ScoringTabContent';
import { updateScore } from 'funnel/actions/score';
import {
  createExclusion,
  updateExclusion,
  removeExclusion,
} from 'funnel/actions/exclusion';

const NoItem = () => (
  <div className="ui message">
    Veuillez ajouter au moins une question et un produit pour pouvoir remplir la
    grille de résultat
  </div>
);

const mapStateToProps = (state, ownProps) => ({
  questions: getQuestionsWithAnswers(state),
  products: getProductsWithDecision(state),
});
const mapDispatchToProps = dispatch => ({
  updateScore: (product, answer, score) =>
    dispatch(updateScore(product, answer, score)),
  createExclusion: product => dispatch(createExclusion(product)),
  updateExclusion: (product, answer, order) =>
    dispatch(updateExclusion(product, answer, order)),
  deleteExclusion: (product, exclusion) =>
    dispatch(removeExclusion(product, exclusion)),
});
class FunnelScoringPage extends React.Component {
  static propTypes = {
    questions: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    createExclusion: PropTypes.func.isRequired,
    updateExclusion: PropTypes.func.isRequired,
    deleteExclusion: PropTypes.func.isRequired,
    updateScore: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      fixed: false,
      fixMargin: '0px',
    };
  }

  componentDidMount() {
    const { table } = this.refs;

    const $table = $(table);
    const $menu = $('nav.ui.menu');

    const isTableFixed = () => $table.offset().top - $menu.outerHeight() < 0;
    const currentLeftScroll = () =>
      $table
        .find('> div:not(.wrapTh) div .tr:eq(0) .td.question')
        .css('marginLeft')
        .replace('px', '');

    // Stick left columns
    $table.scroll(evt => {
      const $table = $(evt.currentTarget);
      const p = $table.scrollLeft();

      $table.find('.tr, .wrapTh .tr').each((index, element) => {
        const $question = $(element).find('.question');
        const $answer = $(element).find('.response');

        $question.css({ marginLeft: 1 * p });
        $answer.css({ marginRight: -1 * p });
      });

      if (isTableFixed()) {
        const scrollLeft = currentLeftScroll();

        this.setState({
          fixMargin: `-${scrollLeft}px`,
        });
      }
    });

    // Stick headers
    $('.app section').scroll(() => {
      const scrollLeft = currentLeftScroll();

      const $answer = $table.find('.tr .th.response');
      $answer.css('marginRight', `-${scrollLeft}px`);

      if (!isTableFixed()) {
        const $question = $table.find('.tr .th.question');

        $question.css('marginLeft', `${scrollLeft}px`);
        this.setState({
          fixMargin: '0px',
        });
      }

      this.setState({
        fixed: isTableFixed(),
      });
    });
  }

  render() {
    const { questions, products } = this.props;

    if (questions.length && products.length) {
      const { fixed, fixMargin } = this.state;
      const tableClass = cx('ui table flexTable', {
        fixed: fixed,
      });

      return (
        <div className="funnel">
          <div className={tableClass} ref="table">
            <ScoringTabHeader
              questions={questions}
              products={products}
              createExclusion={this.props.createExclusion}
              deleteExclusion={this.props.deleteExclusion}
              fixed={fixed}
              fixMargin={fixMargin}
            />
            <ScoringTabContent
              questions={questions}
              products={products}
              updateScore={this.props.updateScore}
              updateExclusion={this.props.updateExclusion}
            />
          </div>
        </div>
      );
    }

    return <NoItem />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FunnelScoringPage);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/FunnelScoringPage.js